import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Building, Truck, Key, ArrowRight, UserCheck, CreditCard, Smartphone } from 'lucide-react';
interface LoesungenProps {
  onNavigate: (page: string) => void;
}
export function Loesungen({
  onNavigate
}: LoesungenProps) {
  return <div className="pb-20" data-id="element-335">
      {/* Hero */}
      <section className="pt-20 pb-16 bg-[#0f0f16]" data-id="element-336">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-337">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-338">
            Lösungen für jede Branche
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8" data-id="element-339">
            Maßgeschneiderte Digital Key und Mobility-Konzepte für OEMs,
            Autohäuser und Flottenbetreiber.
          </p>
        </div>
      </section>

      {/* OEM */}
      <section className="py-16 bg-[#0a0a0f]" data-id="element-340">
        <div className="container mx-auto px-4 md:px-6" data-id="element-341">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-342">
            <div className="md:w-1/2" data-id="element-343">
              <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-344">
                <Building className="w-8 h-8 text-cyan-400" data-id="element-345" />
              </div>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-346">
                OEM & Automotive Partner
              </h2>
              <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-347">
                Wir liefern White-Label-Lösungen und Hardware-Komponenten direkt
                an Hersteller und Importeure. Integrieren Sie unsere Technologie
                nahtlos in Ihre bestehende App oder nutzen Sie unser SDK.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-348">
                <li className="flex items-center text-gray-300" data-id="element-349">
                  <ArrowRight className="w-4 h-4 text-cyan-500 mr-2" data-id="element-350" />{' '}
                  White-Label App & SDK
                </li>
                <li className="flex items-center text-gray-300" data-id="element-351">
                  <ArrowRight className="w-4 h-4 text-cyan-500 mr-2" data-id="element-352" />{' '}
                  Maßgeschneiderte Hardware-Entwicklung
                </li>
                <li className="flex items-center text-gray-300" data-id="element-353">
                  <ArrowRight className="w-4 h-4 text-cyan-500 mr-2" data-id="element-354" />{' '}
                  Integration in Produktionsprozesse
                </li>
              </ul>
            </div>
            <div className="md:w-1/2" data-id="element-355">
              <img src="https://cdn.magicpatterns.com/uploads/21YzftCKL6Cct11vY4CF4y/produktion.jpg" alt="Automotive Factory" className="rounded-2xl shadow-2xl border border-gray-800" data-id="element-356" />
            </div>
          </div>
        </div>
      </section>

      {/* Car Rental Process */}
      <section className="py-20 bg-[#0f0f16]" data-id="element-357">
        <div className="container mx-auto px-4 md:px-6" data-id="element-358">
          <SectionHeading title="Car Sharing/Rental: Der digitale Prozess" subtitle="Vollautomatisierte Vermietung ohne Personalaufwand." align="center" data-id="element-359" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-12 relative" data-id="element-360">
            {/* Connector Line (Desktop) */}
            <div className="hidden md:block absolute top-8 left-0 right-0 h-0.5 bg-gray-800 -z-10 transform translate-y-4" data-id="element-361" />

            {[{
            icon: Smartphone,
            title: '1. Buchung',
            desc: 'Kunde bucht Fahrzeug per App.'
          }, {
            icon: UserCheck,
            title: '2. Verifikation',
            desc: 'Führerschein & ID Check online.'
          }, {
            icon: CreditCard,
            title: '3. Zahlung',
            desc: 'Kaution & Mietpreis hinterlegen.'
          }, {
            icon: Key,
            title: '4. Losfahren',
            desc: 'Digitaler Schlüssel wird freigeschaltet.'
          }].map((step, i) => <div key={i} className="flex flex-col items-center text-center bg-[#0f0f16] p-4" data-id="element-362">
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mb-4 border-4 border-[#0f0f16] z-10" data-id="element-363">
                  <step.icon className="w-6 h-6 text-cyan-400" data-id="element-364" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-365">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-400" data-id="element-366">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Fleet */}
      <section className="py-16 bg-[#0a0a0f]" data-id="element-367">
        <div className="container mx-auto px-4 md:px-6" data-id="element-368">
          <div className="flex flex-col md:flex-row-reverse items-center gap-12" data-id="element-369">
            <div className="md:w-1/2" data-id="element-370">
              <div className="w-16 h-16 bg-blue-500/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-371">
                <Truck className="w-8 h-8 text-blue-400" data-id="element-372" />
              </div>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-373">
                Fleet Management
              </h2>
              <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-374">
                Optimieren Sie die Auslastung Ihrer Flotte. Unser Dashboard gibt
                Ihnen die volle Kontrolle über alle Fahrzeuge, Fahrer und
                Schlüssel.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-375">
                <Card className="p-4 bg-gray-900/50" data-id="element-376">
                  <h4 className="font-bold text-white mb-1" data-id="element-377">
                    Echtzeit-Tracking
                  </h4>
                  <p className="text-xs text-gray-400" data-id="element-378">
                    Live-Position aller Fahrzeuge
                  </p>
                </Card>
                <Card className="p-4 bg-gray-900/50" data-id="element-379">
                  <h4 className="font-bold text-white mb-1" data-id="element-380">Wartungs-Alerts</h4>
                  <p className="text-xs text-gray-400" data-id="element-381">
                    Automatische Service-Meldungen
                  </p>
                </Card>
                <Card className="p-4 bg-gray-900/50" data-id="element-382">
                  <h4 className="font-bold text-white mb-1" data-id="element-383">Fahrer-Logs</h4>
                  <p className="text-xs text-gray-400" data-id="element-384">
                    Digitale Fahrtenbücher
                  </p>
                </Card>
                <Card className="p-4 bg-gray-900/50" data-id="element-385">
                  <h4 className="font-bold text-white mb-1" data-id="element-386">Remote Access</h4>
                  <p className="text-xs text-gray-400" data-id="element-387">
                    Zentrales Öffnen bei Notfällen
                  </p>
                </Card>
              </div>
              <Button onClick={() => onNavigate('contact')} data-id="element-388">
                Beratung anfordern
              </Button>
            </div>
            <div className="md:w-1/2" data-id="element-389">
              <img src="https://cdn.magicpatterns.com/uploads/rYYuTCDd7JMh3NsenfNnNb/flotte.jpg" alt="Fleet Management" className="rounded-2xl shadow-2xl border border-gray-800" data-id="element-390" />
            </div>
          </div>
        </div>
      </section>
    </div>;
}